import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "首頁",
    component: HomeView,
  },
  {
    path: "/collections",
    name: "商品列表",
    component: () => import("../views/ProductListView.vue"),
  },
  {
    path: "/product/:id",
    name: "商品頁面",
    component: () => import("../views/ProductPageView.vue"),
  },
  {
    path: "/checkout",
    name: "結帳",
    component: () => import("../views/CheckoutView.vue"),
  },
  {
    path: "/order_create/:id",
    name: "訂單完成",
    component: () => import("../views/TradeFinishView.vue"),
  },
  {
    path: "/order_search/search",
    name: "訂單查詢頁面",
    component: () => import("../views/OrderSearchView.vue"),
    meta: { requiresAuth: false },
  },
  {
    path: "/order_search/result",
    name: "訂單查詢結果",
    component: () => import("../views/OrderSearchResultView.vue"),
    meta: { requiresAuth: false },
  },
  {
    path: "/account/login",
    name: "會員登入",
    component: () => import("../views/LoginView.vue"),
  },
  {
    path: "/account/forget_pwd",
    name: "忘記密碼",
    component: () => import("../views/ForgetPasswordView.vue"),
  },
  {
    path: "/account/signup",
    name: "會員註冊",
    component: () => import("../views/SignupView.vue"),
  },
  {
    path: "/account/",
    name: "會員中心",
    component: () => import("../views/MemberCenterView.vue"),
    meta: { requiresAuth: true },
    children: [
      {
        path: "dashboard",
        name: "帳戶概覽",
        component: () => import("../views/MemberCenter/DashBoardView.vue"),
      },
      {
        path: "account_edit",
        name: "編輯會員資料",
        component: () => import("../views/MemberCenter/InfoEditView.vue"),
      },
      {
        path: "orders",
        name: "訂單查詢",
        component: () => import("../views/MemberCenter/OrderListView.vue"),
      },
      {
        path: "order/:id",
        name: "訂單詳細",
        component: () => import("../views/MemberCenter/OrderPageView.vue"),
      },
      {
        path: "addresses",
        name: "收件地址管理",
        component: () => import("../views/MemberCenter/AddressListView.vue"),
      },
      {
        path: "coupon",
        name: "優惠券管理",
        component: () => import("../views/MemberCenter/CouponListView.vue"),
      },
    ],
  },
  {
    path: "/news",
    name: "最新消息列表",
    component: () => import("../views/NewsListView.vue"),
  },
  {
    path: "/news/:id",
    name: "最新消息頁面",
    component: () => import("../views/NewsPageView.vue"),
  },
  {
    path: "/contact",
    name: "聯絡我們",
    component: () => import("../views/ContactView.vue"),
  },
  {
    path: "/terms/:id",
    name: "條款頁面",
    component: () => import("../views/TermsView.vue"),
  },
  {
    path: "/event/:id",
    name: "活動頁面",
    component: () => import("../views/EventPageView.vue"),
  },
  {
    path: "/error_page",
    name: "錯誤頁面",
    component: () => import("../views/ErrorPageView.vue"),
  },
  {
    path: "*",
    redirect: "/error_page",
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  // 換頁滾動至最上面
  scrollBehavior: function (to, _from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { el: to.hash, behavior: "smooth" };
    } else {
      window.scrollTo(0, 0);
    }
  },
});

function hasQueryParams(route) {
  return !!Object.keys(route.query).length;
}

router.beforeEach((to, from, next) => {
  if (hasQueryParams(from) && from.query.order_memo) {
    if (to.query && to.query.order_memo) {
      next();
    } else {
      let new_query = null;
      new_query = to.query ? to.query : from.query;
      if (!to.order_memo) {
        new_query.order_memo = from.query.order_memo;
      }
      next({ name: to.name, query: new_query, params: to.params });
    }
  } else {
    next();
  }
});

const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch((err) => err);
};

const VueRouterReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(to) {
  return VueRouterReplace.call(this, to).catch((err) => err);
};

export default router;
